import React from 'react'
import { css } from '@emotion/core'
import { Paragraph } from '@fs/zion-ui'
import { cssGlow } from '../../LcrDemo/common/styles'

// #region Styles
const cssClickableMenuItem = css`
  cursor: pointer;
  ${cssGlow}
`
const cssMenuItem = css`
  margin: 9px 8px;
  padding: 9px 8px;
  cursor: default;
`
// #endregion

/**
 * @describe - Renders a menu item with optional glow effect and dropdown indicator
 */
export default function MenuItemWithGlow({
  children,
  menuText,
  isOpen = false,
  showGlow = false,
  dataTestId,
  onClick,
  onKeyUp,
  'aria-label': ariaLabel,
}) {
  if (children) {
    return <span css={showGlow ? cssClickableMenuItem : undefined}>{children}</span>
  }

  const buttonProps = showGlow
    ? {
        type: 'button',
        onClick,
        onKeyUp,
        'aria-label': ariaLabel,
      }
    : {}

  return (
    <div css={[cssMenuItem, showGlow ? cssClickableMenuItem : undefined]} data-testid={dataTestId} {...buttonProps}>
      <Paragraph size="xs">{`${menuText} ${isOpen ? '▴' : '▾'}`}</Paragraph>
    </div>
  )
}
